import { createContext } from "react";

import { ProjectedChartState } from "./types";

export const ProjectedChartContext = createContext<ProjectedChartState>({} as ProjectedChartState);
